import { z } from 'zod'
import { objectToCamel } from 'ts-case-convert'
import { Shipment } from '../../constants'
import { addressSchema } from './address'
import { fabricOrderSchema } from './fabricOrder'
import * as GarmentSchemas from './garment' // avoid circular dependency
import { loginMicroSchema, supplierSchema } from './user'

//* ---------------- BASE ---------------- *//
const baseShipmentSchema = z.object({
  id: z.number(),
  description: z.string(),
  status: z.enum(Shipment.Status.VALID),
  method: z.string().nullable(),
  carrier: z.string().nullable(),
  tracking_number: z.string().nullable(),
  receive_date: z.coerce.date().nullable(),
  create_date: z.coerce.date(),
  ship_date: z.coerce.date().nullable(),
  shipment_type: z.enum(Shipment.Type.VALID),
  manufacturer_destination: z.string().nullable(),
  tracking_link: z.string().url().nullable(),
})

const baseOvernightShipmentSchema = z.object({
  id: z.number(),
  garment_id: z.number(),
  completed: z.boolean(),
  login_id: z.number(),
  created_at: z.coerce.date(),
  updated_at: z.coerce.date(),
  garment: z.lazy(() => GarmentSchemas.garmentSchema),
  login: loginMicroSchema,
})

//* ---------------- SCHEMAS ---------------- *//
export const shipmentSchema = baseShipmentSchema.transform(objectToCamel)
export const overnightShipmentSchema = baseOvernightShipmentSchema.transform(objectToCamel)

export const shipmentExtendedSchema = baseShipmentSchema
  .extend({
    destination: addressSchema,
    fabric_orders: z.lazy(() => fabricOrderSchema.array()),
    login_id: z.number(),
    shipment_items: z.lazy(() => GarmentSchemas.garmentSchema.array()),
    source: addressSchema,
    supplier: supplierSchema,
  })
  .transform(objectToCamel)

export const deliveryGarmentBoxSchema = baseShipmentSchema.transform(objectToCamel)

//* ---------------- TYPES ---------------- *//
declare global {
  namespace TrinityAPI {
    type ShipmentType = z.infer<typeof shipmentSchema>
    type ShipmentExtendedType = z.infer<typeof shipmentExtendedSchema>
    type DeliveryGarmentBoxType = z.infer<typeof deliveryGarmentBoxSchema>
    type OvernightShipmentType = z.infer<typeof overnightShipmentSchema>
  }
}
